module.exports = __webpack_public_path__ + "7bf745cbe90c43b47ef62d2f3775a699.png";